/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductDto } from '../../models/product-dto';

export interface ProductClientControllerFindByIdV1$Params {
  id: string;
}

export function productClientControllerFindByIdV1(http: HttpClient, rootUrl: string, params: ProductClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
  const rb = new RequestBuilder(rootUrl, productClientControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductDto>;
    })
  );
}

productClientControllerFindByIdV1.PATH = '/api/v1/products/client/{id}';
